import { ReactNode } from "react";
import { AppId } from "@songtradr-one/shared-common";

// TEXT

// STYLES

// DATA

// TYPES
export type Props = {
  config: AppLayoutConfig;
};

export type AppLayoutConfig = {
  appId: AppId;
  appName: string;
  appNavLogo: ReactNode;
  production: boolean;
  coreBackendUrl: string;
  ssoFrontendUrl: string;
  assetsUrl: string;
  helpCenterUrl?: string;
  dromoLicenseKey?: string;
  dromoSchemaId?: string;
  analytics?: {
    [key: string]: {
      enabled: boolean;
      id: string;
    };
  };
  branding?: {
    logo?: string;
    background?: string;
  };
};

// CONSTANTS
export const APP_LAYOUT_ID = "app-layout";

// FUNCTIONS

// ASSETS
